// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Y0UM","label":"styles_label__31w_R"};